export default __webpack_public_path__ + "static/media/avatar_86.60e0dffb.png";